module.exports = __webpack_public_path__ + "img/placehold_post.5510f2b6.png";